import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

import Dashboard from "./admin/Dashboard";
import AdminListings from "./admin/AdminListings";
import AdminSubmissions from "./admin/AdminSubmissions";
import AdminOrders from "./admin/AdminOrders";
import AdminShipping from "./admin/AdminShipping";
import AdminContent from "./admin/AdminContent";

export default function Admin() {
    const { user, loading } = useAuth();
    const [tab, setTab] = useState("dashboard");

    if (loading) return <div className="loading">Loading admin…</div>;
    if (!user || (user.role !== "admin" && user.role !== "staff")) {
        return <Navigate to="/login?next=/admin" replace />;
    }

    return (
        <div className="admin" data-testid="admin-page">
            <div style={{ marginBottom: 24 }}>
                <div className="eyebrow">Admin</div>
                <h1 className="h-section" style={{ fontStyle: "italic" }}>The house.</h1>
            </div>

            <div className="admin-tabs">
                {["dashboard", "listings", "submissions", "orders", "shipping", "content"].map((t) => (
                    <button
                        key={t}
                        className={`admin-tab ${tab === t ? "active" : ""}`}
                        onClick={() => setTab(t)}
                        data-testid={`admin-tab-${t}`}
                    >
                        {t}
                    </button>
                ))}
            </div>

            {tab === "dashboard" && <Dashboard onGo={setTab} />}
            {tab === "listings" && <AdminListings />}
            {tab === "submissions" && <AdminSubmissions />}
            {tab === "orders" && <AdminOrders />}
            {tab === "shipping" && <AdminShipping />}
            {tab === "content" && <AdminContent />}
        </div>
    );
}
